import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose'
import { change } from 'redux-form'
import { connect } from 'react-redux'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import validate from 'components/AppointmentConfirmationPage/AppointmentInfo/validate'
import { getAppointments } from 'selectors/getAppointments'
import { getCurrentStore } from 'selectors/getCurrentStore'
import { getServicesDisplayNames, getSelectedVehicle } from '../../../Stepper/components/Review/selectors'
import { getAppointmentFormValues } from '../../selectors'
import { getTAOSAppointmentDatesAndSlots } from '../../../Stepper/actions'
import { submit3StepperApptRequest } from '../../actions'
import { getFormattedTime } from 'helpers/time-format'
import { generateAddress } from 'helpers/storeLocator'
import {
  APPOINTMENT_FORM_NAME,
  USER_PLAN_FIELD_NAME,
  USER_FIRST_NAME,
  USER_LAST_NAME,
  USER_EMAIL,
  USER_PHONE_NUMBER,
  REVIEW_REQUEST_TITLE,
  REVIEW_APPOINTMENT_TITLE,
  REQUEST_CONTACT_REVIEW_DESCRIPTION,
  SCHEDULE_CONTACT_REVIEW_DESCRIPTION
} from 'constant'
import ContactInfoAndReview from './ContactInfoAndReview'
import { getIsEmailMe } from 'components/MyFavorites/selectors.js'
import { setActivePromotions } from 'components/QuickAppointmentPage/actions'
import { formatPromoListExpiryDates } from '../../helpers'

const mapStateToProps = state => {
  const {
    appointmentDate: { date = '', time: { value: timeStr = '' } = {}} = {},
    firstName,
    lastName,
    email,
    phoneNumber,
    userPlan,
    catalogRefIds,
    activeVehicleId,
    activePromotions
  } = getAppointmentFormValues(state) || {}
  const { servicesList, quoteProductsAndCervices, vehicles, isTrailer } = getAppointments(state)
  const formattedDate = getFormattedTime(date)
  const dateAndTime = timeStr ? `${formattedDate}, ${timeStr}` : formattedDate

  return {
    dateAndTime,
    formInitialValues: {
      [USER_PLAN_FIELD_NAME]: userPlan,
      [USER_FIRST_NAME]: firstName,
      [USER_LAST_NAME]: lastName,
      [USER_PHONE_NUMBER]: phoneNumber,
      [USER_EMAIL]: email
    },
    activeVehicleName: getSelectedVehicle({ vehicles, activeVehicleId, isTrailer }),
    address: generateAddress(getCurrentStore(state) || {}),
    services: catalogRefIds ? getServicesDisplayNames({ servicesList, catalogRefIds }) :
      quoteProductsAndCervices,
    isEmailMe: getIsEmailMe(state),
    activePromotions: formatPromoListExpiryDates(activePromotions)
  }
}

const withShowDetailsState = withState('showDetails', 'setShowDetails', false)
const withLoadingState = withState('isLoading', 'setIsLoading', false)

const withContactInfoAndReviewProps = withProps(({ isE2EAppointment }) => ({
  title: isE2EAppointment ? REVIEW_APPOINTMENT_TITLE : REVIEW_REQUEST_TITLE,
  isE2EAppointment,
  subTitle: isE2EAppointment ? SCHEDULE_CONTACT_REVIEW_DESCRIPTION : REQUEST_CONTACT_REVIEW_DESCRIPTION
}))

const withStepHandlers = withHandlers({
  onSubmit: ({
    submit3StepperApptRequest,
    setCurrentStepIndex,
    activePromotions,
    setActivePromotions,
    setIsLoading
  }) => values => {
    if (!activePromotions.length) {
      setActivePromotions([])
    }

    submit3StepperApptRequest({ ...values, setCurrentStepIndex, setIsLoading })
  },
  onPreviousStep: ({
    onPrevPage,
    beforeNavigatingToDateTimeStep
  }) => () => {
    beforeNavigatingToDateTimeStep()
    onPrevPage()
  }
})

const withHandleEditClick = withHandlers({
  handleEditClick: ({ setCurrentStepIndex, beforeNavigatingToDateTimeStep }) => (e, index) => {
    e.stopPropagation()
    beforeNavigatingToDateTimeStep()
    setCurrentStepIndex(index)
  }
})

const withLifecycle = lifecycle({
  componentDidMount() {
    const {
      change
    } = this.props

    change(APPOINTMENT_FORM_NAME, 'promonOffers', true)
  }
})

export default compose(
  connect(mapStateToProps, {
    submit3StepperApptRequest,
    getTAOSAppointmentDatesAndSlots,
    change,
    setActivePromotions
  }),
  withShowDetailsState,
  withLoadingState,
  withStepHandlers,
  withHandleEditClick,
  withContactInfoAndReviewProps,
  withLifecycle,
  reduxForm({
    validate,
    form: APPOINTMENT_FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(ContactInfoAndReview)
